import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'ArticleCard',
})(({ spacing, brandColors, breakpoints, typography }) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: spacing(2),
    borderRadius: typography.pxToRem(16),
    backgroundColor: brandColors.white,
    '&:hover': {
      boxShadow: '0px 4px 4px 0px rgba(31, 38, 71, 0.08)',
    },
    '&:focus': {
      boxShadow: '0px 0px 16px 0px rgba(31, 38, 71, 0.08)',
      borderColor: brandColors.primaryMain,
    },
  },
  cardTitle: {
    fontWeight: 500,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    marginBottom: spacing(-1),
    [breakpoints.up('md')]: {
      marginBottom: spacing(0),
    },
  },
  cardDescription: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    whiteSpace: 'normal',
    color: brandColors.tintsNeutral20,
    paddingBottom: typography.pxToRem(24),
    [breakpoints.up('sm')]: {
      paddingBottom: typography.pxToRem(35),
      WebkitLineClamp: 4,
    },
    [breakpoints.up('md')]: {
      WebkitLineClamp: 5,
    },
  },
  cardLink: {
    marginTop: 'auto',
    paddingTop: spacing(-1),
    textDecoration: 'underline',
    color: brandColors.mediumBlue,
    '&:hover': {
      color: brandColors.primaryMain,
    },
  },
}));

export default useStyles;
